import React, { useEffect, useState } from 'react'
import { Avatar } from '../components/avatar'
import { Badge } from '../components/badge'
import { Divider } from '../components/divider'
import { Heading, Subheading } from '../components/heading'
import { Select } from '../components/select'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { getRecentBookings } from '../boooking-data'
import { useNavigate, useParams } from 'react-router-dom'
import logoImage from '../assets/images/masar-logo-en.svg'
import logoIconImage from '../assets/images/masar-logo-icon.svg'
import { t } from 'i18next'
import useAuth from '../routes/useAuth'

export function Stat({ title, value, change }) {
    return (
        <div>
            <Divider />
            <div className="mt-6 text-lg/6 font-medium sm:text-sm/6">{title}</div>
            <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8">{value}</div>
            <div className="mt-3 text-sm/6 sm:text-xs/6">
                <Badge color={change.startsWith('+') ? 'lime' : 'pink'}>{change}</Badge>{' '}
                <span className="text-zinc-500">from last week</span>
            </div>
        </div>
    )
}

export default function Home() {
    const [bookings, setBookings] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const { isNSAUser } = useAuth()

    useEffect(() => {
        let isMounted = true

        // Redirect NSA users to passenger-record page
        if (isNSAUser()) {
            navigate('/passenger-record', { replace: true })
            return
        }

        async function fetchBookings() {
            const data = await getRecentBookings()
            if (isMounted) {
                setBookings(data)
                setLoading(false)
            }
        }

        fetchBookings()

        return () => {
            isMounted = false
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // Only run on mount - isNSAUser and navigate are stable

    if (loading) {
        return (
            <div>
                {t('Loading')}
                ...
            </div>
        )
    }

    const redirectRoutes = () => {
        navigate('/route-operations')
    }

    return (
        <>
            <div className="w-40 mb-2 flex items-center gap-2">
                {/* <Avatar src={logoIconImage} className="size-10" /> */}
                <img alt="logo" src={logoImage} className="w-full" />
            </div>
            <Heading>{t('Manage Your Boat and Operations')}</Heading>
            {/* <div className="mt-8 flex items-end justify-between">
                <Subheading>Overview</Subheading>
                <div>
                    <Select name="period">
                        <option value="last_week">Last week</option>
                        <option value="last_two">Last two weeks</option>
                        <option value="last_month">Last month</option>
                        <option value="last_quarter">Last quarter</option>
                    </Select>
                </div>
            </div>
            <div className="mt-4 grid gap-8 sm:grid-cols-2 xl:grid-cols-4">
                <Stat title="Total revenue" value="$2.6M" change="+4.5%" />
                <Stat title="Average booking value" value="$455" change="-0.5%" />
                <Stat title="Tickets sold" value="5,888" change="+4.5%" />
                <Stat title="Pageviews" value="823,067" change="+21.2%" />
            </div>
            <Subheading className="mt-14">Recent bookings</Subheading>
            <Table className="mt-8 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                <TableHead>
                    <TableRow>
                        <TableHeader>Booking ID</TableHeader>
                        <TableHeader>Booked On</TableHeader>
                        <TableHeader>Customer Email</TableHeader>
                        <TableHeader>Activity</TableHeader>
                        <TableHeader>Status</TableHeader>
                        <TableHeader className="text-right">Amount</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {bookings.map(booking => (
                        <TableRow key={booking.id} href={booking.url} title={`Booking #${booking.id}`}>
                            <TableCell>{booking.referenceNumber}</TableCell>
                            <TableCell>{booking.date}</TableCell>
                            <TableCell>{booking.customer.name}</TableCell>
                            <TableCell>
                                <div className="flex items-center gap-2">
                                    <Avatar src={booking.activity.thumbUrl} className="size-6" />
                                    <span>{booking.activity.name}</span>
                                </div>
                            </TableCell>
                            <TableCell className="text-rose-700">{booking.status}</TableCell>
                            <TableCell className="text-right">{booking.amount.usd}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table> */}

            <div className="relative isolate pt-16">
                <div
                    aria-hidden="true"
                    className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                >
                    <div
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#245e73d4] to-[#245e738c] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                    />
                </div>
                <div className="py-24 sm:py-32 lg:pb-20 pt-[150px]">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl text-center">
                            <div className="mt-10 flow-root sm:mt-2"></div>
                            <h1 className="text-balance text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                                {t('Plan and Optimize Routes')}
                            </h1>
                            <p className="mt-6 text-lg leading-8 text-gray-600">
                                {t(
                                    'Monitor, manage, and maintain your fleet in real-time, ensuring your boats are always ready for the next journey.'
                                )}
                            </p>
                            <div className="mt-10 flex items-center justify-center gap-x-6">
                                <button
                                    onClick={() => redirectRoutes()}
                                    className="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    {t('Get started')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    aria-hidden="true"
                    className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                >
                    <div
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#245e73d4] to-[#245e738c] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                    />
                </div>
            </div>
        </>
    )
}
